import { useOffscreenIndicator } from '@/composables/useOffscreenIndicator';

export default {
  name: "OffscreenIndicator",
  
  props: {
    offscreenTop: {
      type: Number,
      required: true,
      validator: (value) => value >= 0,
    },
    offscreenBottom: {
      type: Number,
      required: true,
      validator: (value) => value >= 0,
    },
    offscreenLeft: {
      type: Number,
      required: true,
      validator: (value) => value >= 0,
    },
    offscreenRight: {
      type: Number,
      required: true,
      validator: (value) => value >= 0,
    },
  },

  emits: ['indicator-click'],

  setup(props, { emit }) {
    const {
      showTop,
      showBottom,
      showLeft,
      showRight,
      hasVisibleIndicators,
      arrowIcon,
      badgeColor,
      handleIndicatorClick: baseHandleClick,
    } = useOffscreenIndicator(props);

    const handleIndicatorClick = (direction) => {
      baseHandleClick(direction);
      emit('indicator-click', { direction });
    };

    return {
      showTop,
      showBottom,
      showLeft,
      showRight,
      hasVisibleIndicators,
      arrowIcon,
      badgeColor,
      handleIndicatorClick,
    };
  },
};